import * as singleSpa from 'single-spa';
import * as isActive from './activity-functions';

function initDev(authorizationResponse, urls) {
  singleSpa.registerApplication('@venue/storage', () => System.import('@venue/storage'), isActive.storage, {
    authToken: 'localAuthToken',
    appUrl: 'https://localhost:1202',
    appUIUrl: 'http://localhost:4202',
    authorizationData: authorizationResponse,
    urls: urls
  });

  if (
    authorizationResponse.availablePolicies &&
    authorizationResponse.availablePolicies.indexOf('ProjectNotificationsRead') !== -1
  ) {
    singleSpa.registerApplication(
      '@venue/notifications',
      () => System.import('@venue/notifications'),
      isActive.notifications,
      {
        authToken: 'localAuthToken',
        urls: urls,
        appUIUrl: 'http://localhost:4208',
        authorizationData: authorizationResponse
      }
    );
  }

  window.UrlVenueAppUINotificationsAdmin = 'http://localhost:4215';
  singleSpa.registerApplication(
    '@venue/notifications-admin',
    () => System.import('@venue/notifications-admin'),
    isActive.notifications_admin,
    {
      authToken: 'localAuthToken',
      urls: urls,
      appUIUrl: window.UrlVenueAppUINotificationsAdmin,
      authorizationData: authorizationResponse
    }
  );

  singleSpa.registerApplication(
    '@venue/project-header',
    () => System.import('@venue/project-header'),
    isActive.projectHeader,
    {
      authToken: 'localAuthToken',
      urls: urls,
      appUIUrl: 'http://localhost:4204',
      authorizationData: authorizationResponse
    }
  );

  //TEMP solution for translations qna
  window.UrlVenueAppUIQnA = 'http://localhost:4205';
  singleSpa.registerApplication('@venue/qna', () => System.import('@venue/qna'), isActive.qna, {
    authToken: 'localAuthToken',
    urls: urls,
    appUIUrl: 'http://localhost:4205',
    authorizationData: authorizationResponse
  });

  window.UrlVenueAppUIReporting = 'http://localhost:4206';
  singleSpa.registerApplication('@venue/reporting', () => System.import('@venue/reporting'), isActive.reporting, {
    authToken: 'localAuthToken',
    urls: urls,
    appUIUrl: window.UrlVenueAppUIReporting,
    authorizationData: authorizationResponse
  });

  window.UrlVenueAppUITeams = 'http://localhost:4217';
  singleSpa.registerApplication('@venue/teams', () => System.import('@venue/teams'), isActive.teams, {
    authToken: 'localAuthToken',
    urls: urls,
    appUIUrl: window.UrlVenueAppUITeams,
    authorizationData: authorizationResponse
  });

  window.UrlVenueAppUIReportViewer = 'http://localhost:4207';
  singleSpa.registerApplication(
    '@venue/report-viewer',
    () => System.import('@venue/report-viewer'),
    isActive.reportViewer,
    {
      authToken: 'localAuthToken',
      urls: urls,
      appUIUrl: window.UrlVenueAppUIReportViewer,
      authorizationData: authorizationResponse
    }
  );

  window.UrlDataProtectApi = 'http://localhost:5000/api';
  window.UrlVenueAppUIDataPrivacy = 'http://localhost:4210';
  singleSpa.registerApplication(
    '@venue/data-privacy',
    () => System.import('@venue/data-privacy'),
    isActive.dataPrivacy,
    {
      authToken: 'localAuthToken',
      urls: urls,
      appUrl: window.UrlDataProtectApi,
      appUIUrl: window.UrlVenueAppUIDataPrivacy,
      authorizationData: authorizationResponse
    }
  );

  window.UrlVenueAppUIRedaction = 'http://localhost:4211';
  singleSpa.registerApplication('@venue/redaction', () => System.import('@venue/redaction'), isActive.redaction, {
    authToken: 'localAuthToken',
    urls: urls,
    appUIUrl: window.UrlVenueAppUIRedaction,
    authorizationData: authorizationResponse
  });

  window.UrlVenueAppUIECA = 'http://localhost:4212';
  singleSpa.registerApplication('@venue/eca', () => System.import('@venue/eca'), isActive.eca, {
    authToken: 'localAuthToken',
    urls: urls,
    appUIUrl: window.UrlVenueAppUIECA,
    authorizationData: authorizationResponse
  });

  window.UrlVenueAppUIAuth = 'http://localhost:4213';
  singleSpa.registerApplication('@venue/auth', () => System.import('@venue/auth'), isActive.auth, {
    urls: urls,
    appUIUrl: window.UrlVenueAppUIAuth
  });

  window.UrlVenueAppUIProjectWorkflows = 'http://localhost:4214';
  singleSpa.registerApplication(
    '@venue/projectworkflows',
    () => System.import('@venue/projectworkflows'),
    isActive.projectworkflows,
    {
      urls: urls,
      appUIUrl: window.UrlVenueAppUIProjectWorkflows,
      authorizationData: authorizationResponse
    }
  );

  window.UrlVenueAppUIArchives = 'http://localhost:4216';
  singleSpa.registerApplication('@venue/archives', () => System.import('@venue/archives'), isActive.archives, {
    urls: urls,
    appUIUrl: window.UrlVenueAppUIArchives,
    authorizationData: authorizationResponse
  });

  window.UrlVenueAppUIHeader = 'http://localhost:4218';
  singleSpa.registerApplication('@venue/header', () => System.import('@venue/header'), isActive.header, {
    urls: urls,
    appUIUrl: window.UrlVenueAppUIHeader,
    authorizationData: authorizationResponse
  });

  window.UrlVenueAppUINewHubHeader = 'http://localhost:4221';
  singleSpa.registerApplication('@venue/newhub-header', () => System.import('@venue/newhub-header'), isActive.header, {
    authToken: tokenResponse.authToken,
    authorizationData: authorizationResponse,
    urls: urls,
    appUIUrl: window.UrlVenueAppUINewHubHeader
  });

  window.UrlVenueAppUIProjectList = 'http://localhost:4220';
  singleSpa.registerApplication(
    '@venue/project-list',
    () => System.import('@venue/project-list'),
    isActive.projectList,
    {
      urls: urls,
      appUIUrl: window.UrlVenueAppUIProjectList,
      authorizationData: authorizationResponse
    }
  );

  singleSpa.start({ urlRerouteOnly: true });
}

export { initDev };
